<template>
  <div class="SpamTimes">
    <div>
      <img
        src="@/assets/icons/ic_early_morning.svg"
        width="100"
        height="100"
      />
      <div>
        <h4>Most active times for spam calls</h4>
        <p>8am & 11am - 1pm</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.SpamTimes {
  background: var(--dark-blue);
  text-align: left;
  color: white;
}
.SpamTimes > div {
  display: flex;
  align-items: center;
  max-width: 720px;
  margin: auto;
  padding: 30px 20px;
}
.SpamTimes img {
  width: 72px;
  height: 72px;
  margin-right: 20px;
}
.SpamTimes p {
  margin: 0;
}
@media screen and (min-width: 640px) {
  .SpamTimes img {
    width: 100px;
    height: 100px;
  }
  .SpamTimes h4 {
    font-size: 30px;
    line-height: 37px;
    letter-spacing: -1.03px;
  }
  .SpamTimes p {
    font-size: 22px;
  }
}
</style>